document.addEventListener("DOMContentLoaded", function () {
  // --- 下からふわっと表示（fade-in-up） ---
  const fadeUpElems = document.querySelectorAll('.fade-in-up');
  const fadeUpObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        fadeUpObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });
  fadeUpElems.forEach(el => fadeUpObserver.observe(el));

  // --- 中央から拡大フェードイン（fade-in / fade-in-center） ---
  const fadeCenterElems = document.querySelectorAll('.fade-in, .fade-in-center');
  const fadeCenterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        fadeCenterObserver.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.1
  });
  fadeCenterElems.forEach(el => fadeCenterObserver.observe(el));

  // --- ハンバーガーメニュー開閉 ---
  const toggle = document.querySelector('.menu-toggle');
  const nav = document.querySelector('.jill-nav');

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('open');
    });
  }
// サブメニュー開閉（親リンククリックで）
document.querySelectorAll('.has-submenu-link').forEach(link => {
  link.addEventListener('click', function (e) {
    const parent = link.closest('.menu-item');
    if (parent) {
      e.preventDefault(); // 親メニューのリンク遷移を防止
      parent.classList.toggle('open');
    }
  });
});
  
});
